<template>
  <div class="PipeList">
    <lm-label>Select a Pipe:</lm-label>
    <lm-loading v-if="!pipes" />
    <ul v-else class="" :class="{'has-error': error}">
      <li v-for="pipe in pipes" :key="pipe._id" class="mb-8">
        <h1 class="mb-2 text-gray-900 font-medium">{{ pipe.title }}</h1>
        <p
          v-if="pipe.description"
          class="mb-0 text-gray-700"
          v-html="pipe.description"
        />
        <ul class="">
          <li
            v-for="subpipe in pipe.subpipes"
            :key="subpipe._id"
            class="p-1 border-b cursor-pointer hover:bg-gray-200"
            :class="{'bg-gray-200': data._id === subpipe._id}"
            @click.prevent="pipeSelected(subpipe, pipe._id)"
          >
            <lm-collapse
              ref="Box"
              :title="subpipe.title"
              :meta="subscribedToPipeMessage(subpipe)"
            >
              <p
                v-if="subpipe.description"
                class="mt-2 mb-0 text-gray-700"
                v-html="subpipe.description"
              />
              <!-- <div class="mt-4">
                Adds the following sources:
                <ul class="mt-4">
                  <li
                    v-for="source in subpipe.pipes"
                    :key="source.url"
                    class="m-2 mb-4"
                  >
                    <lm-icon
                      :icon="source.type.toLowerCase()"
                      size="14"
                      class="text-gray-500"
                    />
                    <span class="ml-2">{{ source.title }} </span>
                    <p v-if="source.description" class="text-xxs text-gray-500">
                      {{ source.description }}
                    </p>
                  </li>
                </ul>
              </div> -->
            </lm-collapse>
          </li>
        </ul>
      </li>
    </ul>
    <span v-if="error" class="flex items-center -mt-6 pt-1 text-error text-xs"
      >Please select a Pipe</span
    >
  </div>
</template>

<script>
import LmLabel from '@/components/ui/LmLabel'
import LmLoading from '@/components/ui/LmLoading'
import LmCollapse from '@/components/ui/LmCollapse'
import {mapGetters} from 'vuex'
export default {
  name: 'PipeList',
  components: {LmLabel, LmLoading, LmCollapse},
  data() {
    return {
      data: {},
      error: false,
      pipes: null
    }
  },
  computed: {
    ...mapGetters(['subscribedToPipe'])
  },
  mounted() {
    this.loadPipes()
  },
  methods: {
    loadPipes() {
      if (!this.pipes) {
        this.$store.dispatch('loadPipes').then(pipes => (this.pipes = pipes))
      }
    },
    subscribedToPipeMessage(pipe) {
      const subscribed = this.subscribedToPipe(pipe)
      if (subscribed) {
        return `Subscribed ${this.$options.filters.dateFromNow(
          subscribed.date
        )} ago`
      }
    },
    pipeSelected(pipe, pipeId) {
      this.clearErrors()
      this.data = Object.assign({}, pipe, {pipeId, subPipeId: pipe._id})
      this.$emit('pipeSelected', this.data)
    },
    validateData() {
      this.error = false
      if (this.data) return true
      this.error = true
      return false
    },
    clearErrors() {
      this.error = false
    },
    // Public
    reset() {
      this.data = ''
      this.clearErrors()
    },
    setData(data) {
      this.data = data
    }
  }
}
</script>

<style scoped>
.PipeList .has-error {
  outline: 1px solid theme('colors.error');
}
</style>
